// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__Dg_rO","content":"styles_content__w08Fj","selectAll":"styles_selectAll__2x6Ul"};